import axios from 'axios';

export default {
  // Admin
  findAdminPVCashbacks: (data) => {
    return axios.put(`/api/pv/admin/cashbacks`, data)
      .then(response => {
        return {
          cashbacks: response.data.cashbacks != null
            ? response.data.cashbacks : [],
      }});
  },

  getAdminPVCashback: (payload) => {
    return axios.get(`/api/pv/admin/cashbacks/${payload.entityId}`, payload)
      .then(response => ({
        cashback: response.data.cashback != null
          ? response.data.cashback : {},
      }));
  },

  // COMPANY
  findCompanyCashbacks: (data) => {
    return axios.put('/api/pv/partner/cashbacks', data)
      .then(response => {
        return { cashbacks: response.data.cashbacks != null
          ? response.data.cashbacks : []}
      });
  },

  getCompanyCashback: (payload) => {
    return axios.get(`/api/pv/partner/cashbacks/${payload.cashbackId}`)
      .then(response => ({
        cashback: response.data.cashback != null
          ? response.data.cashback : {},
      }));
  },

  updateAdminCashbackByKey: (data) => {
    return axios.put(`/api/pv/admin/cashbacks/${data.cashbackId}/bykey`, data)
      .then(response => {
        return {
          cashback: response.data.cashback != null
            ? response.data.cashback : {},
          }});
  },
};
